export const EDITABLE_FIELDS = {
    HEADER: 'article_header',
    INGRESS: 'article_ingress',
    BODY: 'article_body',
    AUTHOR: 'article_author',
    PHOTOGRAPHER: 'photographer',
    CAPTION: 'caption',
    IMAGE_DATA: 'image_data',
    SECTION: 'article_section',
    TARGET_MEDIA: 'target_media',
    PAID: 'article_paid',
    AI_CLAUSE: 'ai_clause',
    MULTI_PUBLICATION_TARGET_MEDIAS: 'multi_publication_target_medias',
};

export const USE_RICH_BODY_EDITOR = true;
